import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpResponse,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, map, finalize, catchError } from 'rxjs/operators';

import { AppService } from './app.service';
import { ADMIN_CONSTANT } from './app.model';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  constructor(private service: AppService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const loader = this.service.openLoader();
    const hasCustomAuthorization = request.headers.has('Authorization');
    const headers = request.url.includes('action') || hasCustomAuthorization
      ? {}
      : {
        Authorization: `Bearer ${this.service.getToken(
          ADMIN_CONSTANT.ADMIN_TOKEN_AUTH_TOKEN
        )}`,
        'Refresh-Token': `${this.service.getToken(
          ADMIN_CONSTANT.ADMIN_TOKEN_REFRESH_TOKEN
        )}`,
      };
    const httpHeaders = request.url.includes('fileupload')
      ? { ...headers }
      : { 'Content-Type': 'application/json', ...headers };
    request = request.clone({
      setHeaders: httpHeaders,
    });

    return next.handle(request).pipe(
      retry(1),
      map((response) => {
        if (response instanceof HttpResponse) {
          if (
            !!response.body &&
            !!response.body.Header &&
            !!response.body.Header.AuthToken &&
            !!response.body.Header.RefreshToken
          ) {
            this.service.setToken(
              ADMIN_CONSTANT.ADMIN_TOKEN_AUTH_TOKEN,
              response.body.Header.AuthToken
            );
            this.service.setToken(
              ADMIN_CONSTANT.ADMIN_TOKEN_REFRESH_TOKEN,
              response.body.Header.RefreshToken
            );
          }
        }
        return response;
      }),
      finalize(() => loader.close()),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
          this.service.showToast(`${error.status}: ${error.message}`);
          if (error.status === 401) {
            this.service.onLogout(true);
          }
          // console.dir(errorMessage);
        }
        loader.close();
        return throwError(errorMessage);
      })
    );
  }
}
